import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import ModalPortal from './ModalPortal';
const ModalPortalHoc = (setting) => (ChildComponent) => (props) => (_jsx(ModalPortal, Object.assign({ selector: setting && setting.selector }, { children: _jsx(ChildComponent, Object.assign({}, props)) })));
export default ModalPortalHoc;
